export function ImgFork({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      stroke="currentColor"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* first “plus”‑like shape */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33}
        d="M12.5 4.5h3v3M12.5 15.5h3v-3"
      />
      {/* the curved “arrow‑plus” shape */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33}
        d="M3.33 10h4.682c.733 0 1.1 0 1.446-.083a3 3 0 0 0 .867-.36c.303-.185.562-.444 1.08-.963L15.5 4.5M12 12l3.5 3.5"
      />
    </svg>
  );
}
